// ##### 24-04-02 Komarov: Отображение перечня отелей города или одного отеля, если в Autocomplete был выбран отель
// ##### 25-05-21 Komarov
import React from 'react';
import HotelContent from '../HotelContent/HotelContent';
import HotelRates from '../HotelRates/HotelRates';

// ##### Komarov 2025-07-14
const HotelItem = props => {
  // ##### 25-04-21 Komarov
  return (
    <li className={props.className}>
      <HotelRates
        hotelPrice={props.hotels[props.id].min_price}
        // ##### 25-04-21 Komarov
        id={props.id} // hotel's id
      />

      <HotelContent
        // ##### 25-04-21 Komarov
        id={props.id} // hotel's id
      />
    </li>
  );
};

export default HotelItem;
